export default "__VITE_ASSET__3ae87929__"